import { twMerge } from 'tailwind-merge';

interface FlagProps {
  flag: string;
  language: string;
  className?: string;
}

export const Flag = ({ flag, language, className }: FlagProps) => {
  return (
    <div
      className={twMerge(
        'flex justify-center items-center w-[25px] h-[18px] overflow-hidden rounded-[3px]',
        className
      )}
    >
      <img
        src={`/media/flags/${flag}.svg`}
        alt={`${language} flag`}
        className="w-full h-full object-cover"
      />
    </div>
  );
};
